export const desiredEmploymentTypes = [
  {
    id: 0,
    name: '未回答'
  },
  {
    id: 1,
    name: '正社員として勤務する'
  },
  {
    id: 2,
    name: 'フリーランスを視野に入れている'
  },
  {
    id: 3,
    name: 'どちらも検討している'
  }
] as const;
